/**
 * PriceAlert — Badge visuel d'alerte prix anormal
 * Affiché dans le formulaire "Ajouter un article" quand le PU dépasse
 * significativement la moyenne historique.
 */
import React from "react";
import { AlertTriangle, TrendingUp } from "lucide-react";

const fmt = (n) => Math.round(n || 0).toLocaleString("fr-FR");

export default function PriceAlert({ alert, historicalCount = 0 }) {
  if (!alert) {
    // Si on a de la data mais pas d'alerte, on affiche discrètement l'info "prix cohérent"
    if (historicalCount > 0) {
      return (
        <div className="mt-1 px-2 py-1 rounded text-[10.5px] flex items-center gap-1.5 bg-emerald-950/40 border border-emerald-500/25 text-emerald-300">
          <TrendingUp className="w-3 h-3" strokeWidth={2.4} />
          <span>Prix cohérent avec l&apos;historique ({historicalCount} achat{historicalCount > 1 ? "s" : ""})</span>
        </div>
      );
    }
    return null;
  }
  const isHigh = alert.level === "high";
  return (
    <div
      className={`mt-1 px-2 py-1.5 rounded text-[11px] flex items-start gap-1.5 border ${
        isHigh
          ? "bg-rose-950/50 border-rose-500/40 text-rose-200"
          : "bg-amber-950/40 border-amber-500/30 text-amber-200"
      }`}
      data-testid="price-alert"
    >
      <AlertTriangle className={`w-3.5 h-3.5 mt-0.5 flex-shrink-0 ${isHigh ? "text-rose-400" : "text-amber-400"}`} strokeWidth={2.4} />
      <div className="min-w-0">
        <p className="font-bold leading-tight">
          {isHigh ? "🔺 Prix anormalement élevé" : "⚠️ Prix supérieur à l'historique"}
          <span className="ml-1 opacity-80">(+{alert.diff_pct}%)</span>
        </p>
        <p className="opacity-80 leading-tight mt-0.5">
          Moyenne : <b className="font-mono">{fmt(alert.avg)} F</b> · Dernier : <b className="font-mono">{fmt(alert.last)} F</b>
        </p>
      </div>
    </div>
  );
}
